<script setup lang="ts">
import { useStore } from '@/store/store'
const store = useStore()
store.commit('setPageTitle', 'Organisation')
</script>

<template>
  <q-page flex> Organisation </q-page>
</template>
